import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Services from '@/pages/services/page';
import About from '@/pages/about/page';
import Contact from '@/pages/contact/page';

export const SITE_PATHS = ['/', '/services', '/about', '/contact'];

const pageRoutes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/services', element: <Services /> },
  { path: '/about', element: <About /> },
  { path: '/contact', element: <Contact /> },
  { path: '*', element: <NotFound /> },
];

export default pageRoutes;